export const CONTAINER = "mt-[60px] md:mt-[80px]";
export const BENEFIT_ICONS_CONTAINER =
    "grid grid-cols-1 lg:grid-cols-3 gap-x-[50px] gap-y-[25px] items-center justify-center align-center";
export const INNER_CONTAINER = "my-12";
